import React from "react";
import { useLang } from "../../context/LanguageContext";
import { Info } from "lucide-react";

export const SampleBadge = ({ className = "" }) => {
  const { t } = useLang();
  return (
    <span
      data-testid="sample-data-badge"
      className={`inline-flex items-center gap-1 rounded-full border border-[#D95D39]/40 bg-[#FFECE5] px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wider text-[#9A3A1D] ${className}`}
    >
      <Info className="h-3 w-3" />
      {t.sampleBadge}
    </span>
  );
};

export const SampleDataBanner = () => {
  const { t } = useLang();
  return (
    <div
      data-testid="sample-data-banner"
      className="mb-5 flex items-start gap-3 rounded-xl border border-[#D95D39]/30 bg-[#FFECE5]/60 px-4 py-3 text-sm text-[#7A2E17] sample-data-stripe"
    >
      <Info className="mt-0.5 h-4 w-4 shrink-0 text-[#D95D39]" />
      <p className="leading-snug">{t.sampleDataBanner}</p>
    </div>
  );
};
